import React from 'react';
import BaseText from './BaseText';
import { StyleSheet, View } from 'react-native';
import { Color, CommonProperties } from '../styles';

const MessageAlert = ({ message, style }) => {
  return (
    <View style={[styles.container, style]}>
      <BaseText style={styles.messageText}>{message}</BaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  messageText: {
    color: Color.accent,
    textAlign: 'center',
    backgroundColor: Color.required,
    paddingHorizontal: 40,
    ...CommonProperties.borderRadius,
  },
});
export default MessageAlert;
